<template>
  <layout-gestao>
    <div class="row">
      <div class="col-sm-12">
        <table-data
          :route="url.getList"
          :settings="table.settings"
          :columns="table.columns"
          :inlineFilters="table.filters"
          :autoUpdateFilter="table.autoUpdateFilter"
          :addParamsToUrl="table.addParamsToUrl"
          :loadingMsg="table.loadingMsg"
          :notFoundMsg="table.notFoundMsg"
          :orderByTemplate="table.orderByTemplate"
          @error-load="showError"
        >
          <template #filters="{ tableFilters, search }">
            <form
              autocomplete="false"
              @submit.prevent=""
              @keyup.enter="search"
            >
              <div class="row header">
                <div class="col-12">
                  <header-list
                    v-model="tableFilters.q"
                    :title="pageTitle"
                    :placeholderSearch="searchPlaceholder"
                    :routeAddName="`${moduleInternalCode}.${pageID}.create`"
                    :canAdd="canAdd"
                    :addTitle="addTitle"
                  >
                    <template v-if="canConfig" #buttons-right>
                      <router-link
                        title="Configurações"
                        class="btn btn-main btn-rounded btn-sm min-w-auto px-3"
                        :to="{ name: `${moduleInternalCode}.${pageID}.config` }"
                      >
                        <i class="fas fa-cogs" />
                      </router-link>
                    </template>
                  </header-list>
                </div>
              </div>
            </form>
          </template>

          <template #body="{row, index, remove}">
            <td :class="[table.columns[0].class, {'tbl-column-disabled': !row.status}]">
              {{ row.name }}
            </td>
            <td :class="table.columns[1].class" v-html="columnScale(row.scale)" />
            <column-actions
              v-if="checkActions"
              :routeEdit="`${moduleInternalCode}.${pageID}.show`"
              :canDetail="canDetail"
              :canEdit="canEdit"
              :canDelete="canDelete"
              :row="row"
              :index="index"
              :callbackDelete="remove"
              @delete="deleteItem"
            />
          </template>
        </table-data>
      </div>
    </div>
  </layout-gestao>
</template>

<script>
    import mixin from '../../../../mixin';

    export default {
        mixins: [mixin],
        data() {
          const pageID = 'municipal_interventions_reports';
            return {
                pageID: pageID,
                pageTitle: this.$t(`${pageID}.titles`),
                table: {
                    columns: [
                        {
                            label: this.$t(`${pageID}.model.name`),
                            field:  'name',
                            class: '',
                            sortable: true,
                        },
                        {
                            label: this.$t(`${pageID}.model.scale`),
                            field:  '',
                            class: 'd-none d-md-table-cell',
                        },
                        {
                            label: '',
                            field:  null,
                            sortable: false,
                            class: 'actions',
                        }
                    ],
                },
            }
        },
        methods: {
            columnScale(scale){
                return scale ? scale.scale : this.$t(`${this.pageID}.model.flex_scale`);
            },
        }
    }
</script>

<style scoped lang="scss">

</style>
